import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PhotoGallery from '../../../../shared/components/PhotoGallery/PhotoGallery';
import useBreakpoint, { SIZE_MD, SIZE_XS } from '../../../../shared/hooks/useBreakpoint';
import i18n from '../../../../utils/i18n';
import Audience from '../components/Audience';
import BasicData from '../components/BasicData';
import Posts from '../../../../shared/components/Analytics/Posts';
import Profile from '../../../../shared/components/Analytics/Profile';

const Tiktok = ({
  data
}) => {
  const breakpoint = useBreakpoint();
  const { t } = useTranslation();

  if (!data) return;

  return (<div className="page">
    <Container>
      <h3 className='mb-4 mb-sm-5'>
        {t('influencers.common.tiktok')}
      </h3>

      <Row>
        <Col xs={12} md={6} lg={3}>
          <BasicData data={data} />
        </Col>

        {[SIZE_XS, SIZE_MD].includes(breakpoint) && <Col xs={12} className="p-0"><hr className='my-6' /></Col>}

        <Col xs={12} lg={{
          offset: 1,
          span: 8
        }}>
          <Profile data={data}
            engagementRate />
          <Posts data={data}
            averageShares
            averageComments />
          <Audience data={data}
            audienceByCountry
            audienceByAge
            audienceByGender
          />

          {
            data.username &&
            <React.Fragment>
              <h4 className='mb-5'>
                {t('influencers.pages.analytics.sample_posts')}
              </h4>
              <PhotoGallery xs={1} sm={2} md={3} username={data.username} platform="tiktok" analytics={true}/>
            </React.Fragment>
          }

        </Col>
      </Row>
    </Container>
  </div >);
};


export default React.memo(Tiktok);